import { OverlayType } from '../constants/common'
import ExponentialMovingAverage from '../helpers/ema'
import Overlay from './overlay'

interface Attrs {
  period: number
  deviations: number
  color: string
}

class EMA extends Overlay<Attrs> {
  static type = OverlayType.Ema
  static label = 'Exponential Moving Average'

  set(obj: Partial<Attrs>) {
    super.set(obj)
    const { period } = obj
    if (typeof period === 'string') {
      this.attrs.period = parseInt(period, 10)
      this.trigger('change')
    }
    return this
  }

  renderContent(context: CanvasRenderingContext2D) {
    super.renderContent()
    const { leftOffset, width } = this.model.chart()
    const ema = new ExponentialMovingAverage(this.attrs.period)

    context.translate(0.5, 0.5)
    context.beginPath()
    context.set('lineWidth', 1)
    context.set('strokeStyle', this.attrs.color)
    for (let i = 0; i < this.data.close.length; i++) {
      ema.add(this.data.close[i])
      const x = this.fx(i)
      if (this.fx(i + 1) + leftOffset < 0) {
        continue
      }
      if (this.fx(i - 1) + leftOffset > width) {
        break
      }
      context.lineTo(x, Math.round(this.fy(ema.value)))
    }
    context.stroke()
    context.translate(-0.5, -0.5)
  }

  getModalConfig() {
    const period = {
      type: 'number',
      label: 'Period',
      name: 'period',
      value: this.attrs.period ?? 5,
      required: true,
      min: 1,
      max: 999999,
    }
    const color = {
      type: 'color',
      label: 'Color',
      name: 'color',
      value: this.attrs.color ?? this.getFreeColor(),
    }

    return {
      title: this.label,
      inputs: [period, color],
      inputsErrorMessages: {
        period: `${period.label} must be a whole number between ${period.min} and ${period.max}`,
      },
    }
  }

  getIsValid(key: string) {
    switch (key) {
      case 'period':
        return this.getIsNumberInputValid({ key })
      case 'color':
        return !!this.attrs[key] // use real color validation, we got isValidHexColor but it might be also RGBA
      default:
        return false
    }
  }

  toString() {
    return `EMA ${this.attrs.period}`
  }
}

EMA.prototype.defaults = { color: '#ffa75f' }

export default EMA
